
import Vue from "vue";
import AppErrorMessageBox from "@/components/common/ErrorMessageBox.vue";
import {TranslateResult} from "vue-i18n";
import { InboxreaderService } from "@/services/inboxreader-service";

export default Vue.extend({
	data(){
		return {
			alias: "",
			aliasIsInUse: false,
			checkingIsAvailable: false,
			isFocused: false
		};
	},
	computed: {
		aliasIsValid():boolean {
			if (this.aliasIsInUse) return false;
			if (!this.alias.match(/^[0-9a-zA-Z\._-]*$/)) return false;
			return true;
		},
		showErrorMessage():boolean{
			if (this.isFocused) return false;
			return !this.aliasIsValid;
		},
		canSave():boolean {
			return this.aliasIsValid && !this.checkingIsAvailable && !this.isFocused;
		},
		errorMessage():string | TranslateResult{
			if (!this.showErrorMessage) return "";
			if (this.aliasIsInUse) {
				return this.$ct("inbox-reader-alias-is-in-use");
			}
			if (!this.aliasIsValid) {
				return this.$ct("inbox-reader-alias-invalid-format");
			}
			return "";
		}
	},
	methods: {
		async checkAliasIsAvailable(){
			this.checkingIsAvailable = true;
			try{
				if (!this.alias) {
					this.aliasIsInUse = false;
				}else{
					this.aliasIsInUse = !(await InboxreaderService.isInboxReaderAliasAvailable(this.alias));
				}
			}catch(err){
			}finally{
				this.checkingIsAvailable = false;
			}
		},
		async save(){
			await InboxreaderService.setInboxReaderAlias(this.alias);
			this.close();
		},
		close(){
			this.$emit("close");
		},
		onFocus(){
			this.isFocused = true;
		},
		onBlur(){
			this.isFocused = false;
			this.checkAliasIsAvailable();
		}
	},
	async created(){
		this.alias = await InboxreaderService.getInboxReaderAlias();
	},
	components: {
		AppErrorMessageBox
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
